module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Website-w540.ad80f74d.jpg";